module.exports = __webpack_public_path__ + "static/img/img-honor6.55684ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-honor6.png
// module id = 4Vsc
// module chunks = 1